import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { id: "style-4" }
const _hoisted_2 = { className: "card card-custom" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { className: "card-header border-0" }, [
  /*#__PURE__*/_createVNode("h3", { className: "card-title font-weight-bolder text-dark" }, " Últimos Laudos Efetuados ")
], -1)
const _hoisted_4 = { className: "d-flex flex-wrap align-items-center border-bottom pb-5" }
const _hoisted_5 = { className: "d-flex align-items-center w-100 justify-content-between" }
const _hoisted_6 = { className: "d-flex flex-column flex-grow-1 my-lg-0 my-2 pr-3" }
const _hoisted_7 = { class: "fs-5" }
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "bi bi-ui-checks fs-3" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Ver laudo ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.laudos, (laudo) => {
        return (_openBlock(), _createBlock("div", {
          className: "card-body pt-2",
          key: laudo.id
        }, [
          _createVNode("div", _hoisted_4, [
            _createVNode("span", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _createVNode("a", {
                  href: `https://app.pryal.com.br/#/laudo/${laudo.id}`,
                  target: "_blank"
                }, [
                  _createVNode("span", _hoisted_7, _toDisplayString(laudo.marca) + " - " + _toDisplayString(laudo.modelo) + " | " + _toDisplayString(laudo.placa), 1)
                ], 8, ["href"]),
                _createVNode("span", null, _toDisplayString(laudo.nome), 1)
              ]),
              _createVNode(_component_router_link, {
                class: "btn btn-sm btn-light-primary",
                to: { name: 'Cadastrar-laudo', params: { analiseId: laudo.id } }
              }, {
                default: _withCtx(() => [
                  _hoisted_8,
                  _hoisted_9
                ]),
                _: 2
              }, 1032, ["to"])
            ])
          ])
        ]))
      }), 128))
    ])
  ]))
}